import { ApolloLink } from '@apollo/client';
import Cookies from 'js-cookie';

import {
  DEBUG_LEVEL_COOKIE,
  DebugLevel,
  debugLevelVar,
} from '../contexts/debugContext/debug.context';

export const debugHeaderLink = new ApolloLink((operation, forward) => {
  const debugLevel =
    Cookies.get(DEBUG_LEVEL_COOKIE) === DebugLevel.VERBOSE.toString()
      ? DebugLevel.VERBOSE
      : debugLevelVar();

  if (debugLevel !== null) {
    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        'X-Lum-Debug-Level': debugLevel.toString(),
      },
    }));
  }

  return forward(operation);
});
